import { useTranslation } from 'react-i18next'
import { PaymentSummaryAmount as SharedPaymentSummaryAmount, type PaymentSummaryAmountProps as SharedProps } from '@jagad/ui'

type PaymentSummaryAmountProps = Pick<SharedProps, 'amount' | 'currentBalance' | 'onTopUpPress'>

export default function PaymentSummaryAmount({ amount, currentBalance, onTopUpPress }: PaymentSummaryAmountProps) {
  const { t } = useTranslation()

  return (
    <SharedPaymentSummaryAmount
      amount={amount}
      currentBalance={currentBalance}
      onTopUpPress={onTopUpPress}
      labelText={t('paymentSummary.totalAmount')}
      insufficientBalancePrefix={t('paymentSummary.insufficientBalancePrefix')}
      insufficientBalanceSuffix={t('paymentSummary.insufficientBalanceSuffix')}
      topUpLabel={t('paymentSummary.topUp')}
    />
  )
}
